import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

/**
 * CountryDropdown renders the country selector dropdown for the TelephoneInput
 * @displayName CountryDropdown
 * @class CountryDropdown
 *
 */
export default class CountryDropdown extends PureComponent {
  /**
   * Render the country dropdown
   *
   * @returns {React.DOM} rendered component
   * @private
   */
  render() {
    const { countryData, onCountrySelect, activeClassName } = this.props;
    const selected = this.props.selectedCountry;

    const onSelectedClick = (event) => onCountrySelect(event, selected);

    return <ul id='phoneCountryList' className='dropdown-menu dropdown-menu-items' role='menu'>
      <div id={ selected.countryKey }
        key={ selected.countryKey }
        role='presentation'
        className={ activeClassName }
        onClick={ onSelectedClick }>
        <a role='menuitem'>
          <span className='country-id'>{ selected.countryKey } </span>
          <span className='country-name'>{ selected.label } </span>
          <span className='dial-code'>{ '+' + selected.callingCode } </span>
        </a>
      </div>

      {
        countryData.map((country) => {
          if (country.countryKey === selected.countryKey) { return; }

          const onClick = (event) => onCountrySelect(event, country);

          return (
            <div id={ country.countryKey }
              key={ country.countryKey }
              role='presentation'
              className='dropdown-item'
              onClick={ onClick }>
              <a role='menuitem'>
                <span className='country-id'>{ country.countryKey } </span>
                <span className='country-name'>{ country.label } </span>
                <span className='dial-code'>{ '+' + country.callingCode } </span>
              </a>
            </div>
          );
        })
      }
    </ul>;
  }
}

CountryDropdown.propTypes = {
  /** An array of countries and their associated calling data. */
  countryData: PropTypes.array.isRequired,
  /** Selected country object which will render first in the dropdown list before the rest of countryData. */
  selectedCountry: PropTypes.object.isRequired,
  /** Styles applied for the active item */
  activeClassName: PropTypes.string.isRequired,
  /** Handle country selection, update the phone number with the calling code and notify the parent of the change */
  onCountrySelect: PropTypes.func.isRequired
};
